import React from 'react'
import { useLocation } from 'react-router-dom'

/**
 * @function
 * @description Returns the search params for the url that got us to the component.
 * @returns {Function} URLSearchParams
 */
const useSearchParams = () => {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}
  
export default useSearchParams